export const ACTION_TYPES = {
  DELETE_COMMENT_SUCCESS: 'DELETE_COMMENT_SUCCESS',
};
